// User-facing copy for the per-player communication log. Type labels stay in
// `email-log-list.utils.tsx`: they key a lookup, not a rendered descriptor.

import { defineMessages } from 'react-intl';

export const scope = 'app.components.CommunicationList';

// The delivery caption. The ice-time line is rendered by the shared
// AssessmentSessionSummary, which owns its own copy.
export const messages = defineMessages({
  scheduledAt: {
    id: `${scope}.scheduledAt`,
    defaultMessage: 'Scheduled @ {when}',
  },
  sentAt: {
    id: `${scope}.sentAt`,
    defaultMessage: 'Sent @ {when}',
  },
});
